import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ManufacturedHomeDetail {
		constructor(doc)
		{
		this.label = null;
		this.manufacturedHomeAttachedToFoundationIndicator = null;
		this.manufacturedHomeHitchWheelsAxlesRemovedIndicator = null;
		this.manufacturedHomeHUDCertificateLabelIndicator = null;
		this.manufacturedHomeHUDDataPlateAttachedIndicator = null;
		this.manufacturedHomeInstalledDate = null;
		this.manufacturedHomeInstalledDateEstimatedIndicator = null;
		this.manufacturedHomeInvoiceNotReasonableDescription = null;
		this.manufacturedHomeInvoiceReasonableIndicator = null;
		this.manufacturedHomeInvoiceReviewedIndicator = null;
		this.manufacturedHomeManufactureDate = null;
		this.manufacturedHomeManufacturerName = null;
		this.manufacturedHomeModificationIndicator = null;
		this.manufacturedHomeModificationsDescription = null;
		this.manufacturedHomeMovedAfterOriginalInstallationIndicator = null;
		this.manufacturedHomePurchasedFromRetailerIndicator = null;
		this.manufacturedHomeRetailerInvoiceReviewedIndicator = null;
		this.manufacturedHomeRetailerName = null;
		this.manufacturedHomeSerialNumberIdentifier = null;
		this.manufacturedHomeValuationCommentText = null;
		this.manufacturedHomeWidthType = null;
		this.roofLoadZoneCode = null;
		this.skirtingExistsIndicator = null;
		this.thermalZoneCode = null;
		this.windZoneCode = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.manufacturedHomeAttachedToFoundationIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeAttachedToFoundationIndicator");
		this.manufacturedHomeHitchWheelsAxlesRemovedIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeHitchWheelsAxlesRemovedIndicator");
		this.manufacturedHomeHUDCertificateLabelIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeHUDCertificateLabelIndicator");
		this.manufacturedHomeHUDDataPlateAttachedIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeHUDDataPlateAttachedIndicator");
		this.manufacturedHomeInstalledDate = x.getMISMODateElement(doc, "./ns:ManufacturedHomeInstalledDate");
		this.manufacturedHomeInstalledDateEstimatedIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeInstalledDateEstimatedIndicator");
		this.manufacturedHomeInvoiceNotReasonableDescription = x.getStringElement(doc, "./ns:ManufacturedHomeInvoiceNotReasonableDescription");
		this.manufacturedHomeInvoiceReasonableIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeInvoiceReasonableIndicator");
		this.manufacturedHomeInvoiceReviewedIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeInvoiceReviewedIndicator");
		this.manufacturedHomeManufactureDate = x.getMISMODateElement(doc, "./ns:ManufacturedHomeManufactureDate");
		this.manufacturedHomeManufacturerName = x.getStringElement(doc, "./ns:ManufacturedHomeManufacturerName");
		this.manufacturedHomeModificationIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeModificationIndicator");
		this.manufacturedHomeModificationsDescription = x.getStringElement(doc, "./ns:ManufacturedHomeModificationsDescription");
		this.manufacturedHomeMovedAfterOriginalInstallationIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeMovedAfterOriginalInstallationIndicator");
		this.manufacturedHomePurchasedFromRetailerIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomePurchasedFromRetailerIndicator");
		this.manufacturedHomeRetailerInvoiceReviewedIndicator = x.getBooleanElement(doc, "./ns:ManufacturedHomeRetailerInvoiceReviewedIndicator");
		this.manufacturedHomeRetailerName = x.getStringElement(doc, "./ns:ManufacturedHomeRetailerName");
		this.manufacturedHomeSerialNumberIdentifier = x.getStringElement(doc, "./ns:ManufacturedHomeSerialNumberIdentifier");
		this.manufacturedHomeValuationCommentText = x.getStringElement(doc, "./ns:ManufacturedHomeValuationCommentText");
		this.manufacturedHomeWidthType = x.getStringElement(doc, "./ns:ManufacturedHomeWidthType");
		this.roofLoadZoneCode = x.getStringElement(doc, "./ns:RoofLoadZoneCode");
		this.skirtingExistsIndicator = x.getBooleanElement(doc, "./ns:SkirtingExistsIndicator");
		this.thermalZoneCode = x.getStringElement(doc, "./ns:ThermalZoneCode");
		this.windZoneCode = x.getStringElement(doc, "./ns:WindZoneCode");
	 }
}

export class ManufacturedHomeFinancingProgram {
		constructor(doc)
		{
		this.label = null;
		this.manufacturedHomeFinancingProgramEligibilityIdentifier = null;
		this.manufacturedHomeFinancingProgramEligibilityType = null;
		this.manufacturedHomeFinancingProgramEligibilityTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.manufacturedHomeFinancingProgramEligibilityIdentifier = x.getStringElement(doc, "./ns:ManufacturedHomeFinancingProgramEligibilityIdentifier");
		this.manufacturedHomeFinancingProgramEligibilityType = x.getStringElement(doc, "./ns:ManufacturedHomeFinancingProgramEligibilityType");
		this.manufacturedHomeFinancingProgramEligibilityTypeOtherDescription = x.getStringElement(doc, "./ns:ManufacturedHomeFinancingProgramEligibilityTypeOtherDescription");
	 }

	GetEligibilityType() {
		return h.descriptionOrOther(this.manufacturedHomeFinancingProgramEligibilityType, this.manufacturedHomeFinancingProgramEligibilityTypeOtherDescription);
	}

}

export class ManufacturedHomeModification {
		constructor(doc)
		{
		this.label = null;
		this.manufacturedHomeModificationType = null;
		this.manufacturedHomeModificationTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.manufacturedHomeModificationType = x.getStringElement(doc, "./ns:ManufacturedHomeModificationType");
		this.manufacturedHomeModificationTypeOtherDescription = x.getStringElement(doc, "./ns:ManufacturedHomeModificationTypeOtherDescription");
	 }

	GetModificationType() { 
		return h.descriptionOrOther(this.manufacturedHomeModificationType, this.manufacturedHomeModificationTypeOtherDescription); 
	}

}

export class ManufacturedHomeSection {
		constructor(doc)
		{
		this.label = null;
		this.manufacturedHomeHUDCertificationLabelIdentifier = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.manufacturedHomeHUDCertificationLabelIdentifier = x.getStringElement(doc, "./ns:ManufacturedHomeHUDCertificationLabelIdentifier");
	 }
}

export class SkirtingMaterial {
		constructor(doc)
		{
		this.label = null;
		this.skirtingMaterialType = null;
		this.skirtingMaterialTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.skirtingMaterialType = x.getStringElement(doc, "./ns:SkirtingMaterialType");
		this.skirtingMaterialTypeOtherDescription = x.getStringElement(doc, "./ns:SkirtingMaterialTypeOtherDescription");
	 }

	 GetMaterialType() {
		return h.descriptionOrOther(this.skirtingMaterialType, this.skirtingMaterialTypeOtherDescription)
	 }
}

export class ManufacturedHome {
		constructor(doc)
		{
		this.label = null;
		this.manufacturedHomeDetail = null;
		this.manufacturedHomeFinancingPrograms = [];
		this.manufacturedHomeModifications = [];
		this.manufacturedHomeSections = [];
		this.skirtingMaterials = [];
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:MANUFACTURED_HOME_DETAIL");
		if (node !== null)
				this.manufacturedHomeDetail = new ManufacturedHomeDetail(node);
		nodes = x.selectNodes(doc, "./ns:MANUFACTURED_HOME_FINANCING_PROGRAMS/ns:MANUFACTURED_HOME_FINANCING_PROGRAM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.manufacturedHomeFinancingPrograms.push(new ManufacturedHomeFinancingProgram(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:MANUFACTURED_HOME_MODIFICATIONS/ns:MANUFACTURED_HOME_MODIFICATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.manufacturedHomeModifications.push(new ManufacturedHomeModification(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:MANUFACTURED_HOME_SECTIONS/ns:MANUFACTURED_HOME_SECTION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.manufacturedHomeSections.push(new ManufacturedHomeSection(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:SKIRTING_MATERIALS/ns:SKIRTING_MATERIAL");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.skirtingMaterials.push(new SkirtingMaterial(xn));
			});
		}
	 }

	GetModificationTypes() {
		let mods = '';
		if (!this.manufacturedHomeModifications) return mods;
		for (const mhm of this.manufacturedHomeModifications) {
				mods = h.addWithSpacer(mods, mhm.getModificationType());
		}
		return mods;
	}

	GetCertificationNumbers() {
		const list = [];
		for (const mhs of this.manufacturedHomeSections) {
			list.push(mhs.manufacturedHomeHUDCertificationLabelIdentifier);
		}
		return list;
	}

	GetFinancingEligibility() {
		const list = [];
		if (!this.manufacturedHomeFinancingPrograms) return list;
		for (const mhfp of this.manufacturedHomeFinancingPrograms) {
				const item = [];
				item[0] = mhfp.GetEligibilityType();
				item[1] = mhfp.manufacturedHomeFinancingProgramEligibilityIdentifier;
				list.push(item);
		}
		return list;
	}

	GetSkirting() {
		let skirting = '';
		if (!(this.manufacturedHomeDetail.skirtingExistsIndicator ?? false)) return 'None';
		for (const sm of this.skirtingMaterials) {
				skirting = h.addWithSpacer(skirting, sm.GetMaterialType());
		}
		return skirting;
	}
}
